import FuseLoadable from '@fuse/components/FuseLoadable/FuseLoadable'

export const QuotazioniConfig = {
  settings: {
    layout: {
      config: {}
    }
  },
  routes: [
    {
      path: '/quotazione/:id/doc-validator',
      component: FuseLoadable({
        loader: () => import('./doc-validator/DocValidator')
      })
    },
    {
      path: '/quotazione/:id?',
      component: FuseLoadable({
        loader: () => import('./Quotazioni')
      })
    },
    {
      path: '/sinistri',
      component: FuseLoadable({
        loader: () => import('./ListaSinistri')
      })
    },
    {
      path: '/item',
      component: FuseLoadable({
        loader: () => import('./ListaItems')
      })
    },
    {
      path: '/polizza/:id?',
      component: FuseLoadable({
        loader: () => import('./polizze/Polizze')
      })
    },
    {
      path: '/in-emissione',
      component: FuseLoadable({
        loader: () => import('./ListaInEmissione')
      })
    }
  ]
}
